import "./certifications.css";
import { useTranslation } from "react-i18next";

const CertificationsSection = () => {
  const { t } = useTranslation();
  return (
    <div className="certifications-container">
      <p className="section-heading">{t("We are Certified & Trusted")}</p>
      <h2 className="heading">{t("Your business is safe with us")}</h2>
      <p className="sub-text">
        {t("Sigvion proudly upholds compliance with esteemed certifications, ensuring our commitment to excellence in data protection, quality management, and security standards.")}
      </p>

      <div className="certifications-container-width">
        {/* GDPR */}
        <div className="certification-item gdpr-item">
          <img
            src="/assets/images/gdpr-logo.webp"
            alt="GDPR Logo"
            className="cert-logo gdpr-logo"
          />
          <p className="cert-title">
            GDPR <br />
            <span>{t("Compliant")}</span>
          </p>
        </div>

        {/* ISO */}
        <div className="certification-item iso-item">
          <img
            src="/assets/images/iso-logo.webp"
            alt="ISO Logo"
            className="cert-logo iso-logo"
          />
          <div className="iso-list">
            <p>ISO 9001</p>
            <p>ISO 27001</p>
            <p>ISO 27034</p>
            <p>ISO 12207</p>
            <p>ISO 22301</p>
            <p>ISO 20000</p>
          </div>
        </div>

        {/* TISAX */}
        <div className="certification-item tisax-item">
          <img
            src="/assets/images/tisax-logo.webp"
            alt="TISAX Logo"
            className="cert-logo tisax-logo"
          />
          <p className="cert-title">
            TISAX <br />
            <span>{t("Compliant")}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CertificationsSection;
